<div class="box box1">
    <div class="homeContent">
        <h1 style="text-align: center;">Mutatók</h1>
        <table style="border-collapse: collapse;">
            <tbody>
                <tr>
                    <td width="10%">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;"><b>Kategória típus</b></span></p>
                    </td>
                    <td width="10%">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;"><b>Év / <br>Negyedév</b></span>
                        </p>
                    </td>
                    <td width="15%">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;"><b>Elméleti díj <br>(Ft / fő)</b></span></p>
                    </td>
                    <td width="15%">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;"><b>Gyakorlati díj <br>(Ft / ó)</b></span></p>
                    </td>
                    <td width="14%">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;"><b>Képzési Költség<br>(KK)<br>Gyakorlat + Elmélet</b></span></p>
                    </td>
                    <td width="18%">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;"><b>Általános Képzési Óraszám Mutató<br>(ÁKÓ)<br>gyakorlat</b></span></p>
                    </td>
                    <td width="18%">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;"><b>Vizsga Sikerességi Mutató<br>(VSM)</b></span></p>
                    </td>
                </tr>
                <tr>
                    <td rowspan="4">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">A1</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">2026.02.</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">35.000 Ft</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">10.000 Ft</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">195.000 Ft</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">-</span></p>
                    </td>
                    <td>
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">Elmélet: -</span></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">Forgalom: -</span></p>
                    </td>
                </tr>
                <tr>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">2026.03.</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">35.000 Ft</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">10.000 Ft</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">195.000 Ft</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">-</span></p>
                    </td>
                    <td>
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">Elmélet: -</span></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">Forgalom: -</span></p>
                    </td>
                </tr>

                <tr>
                    <td rowspan="4">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">A</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">2026.02.</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">35.000 Ft</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">10.000 Ft</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">295.000 Ft</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">-</span></p>
                    </td>
                    <td>
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">Elmélet: -</span></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">Forgalom: -</span></p>
                    </td>
                </tr>
                <tr>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">2026.03.</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">35.000 Ft</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">10.000 Ft</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">305.000 Ft</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">-</span></p>
                    </td>
                    <td>
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">Elmélet: -</span></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">Forgalom: -</span></p>
                    </td>
                </tr>

                <tr>
                    <td rowspan="4">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">B</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">2026.02.</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">35.000 Ft</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">8.000 Ft</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">455.000 Ft</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">-</span></p>
                    </td>
                    <td>
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">Elmélet: 61,54%</span></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">Forgalom: 72,73%</span></p>
                    </td>
                </tr>
                <tr>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">2026.03.</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">35.000 Ft</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">8.000 Ft</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">425.000 Ft</span></p>
                    </td>
                    <td rowspan="2">
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">-</span></p>
                    </td>
                    <td>
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">Elmélet: -</span></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p align="center" style="line-height: 1.3;"><span style="font-family: Times New Roman,serif;">Forgalom: -</span></p>
                    </td>
                </tr>
            </tbody>
        </table>

          <p>Átlagos adminisztrációs képzési költség (KKa): Költségtétel és egyszeri díj NINCS</p>
          <p>Elméleti képzési átlagos költsége (KKe): Költségtétel és egyszeri díj NINCS</p>

        <h1 style="text-align: center;">Egyéb</h1>
        <p>OKÉV szám: 04-0055-04</p>
        <p>Felnőttképzési nyilvántartási szám: B/2020/009192</p>
        <p>Írásos Tájékoztató: <a href="assets/irtajek.pdf">Megtekint</a></p>
        <p>Információs önrendelkezési jogról és az információszabadságról: <a
                href="assets/informaciosJog.pdf">Megtekint</a></p>
        <p>Felnőttképzési Szerződés: <a href="assets/felnottkepzszerz.pdf">Megtekint</a></p>
    </div>
    <div class="footer"></div>
</div>